const ConvertDataMenuForShow = (dataMenus) => {
  let arrMenu = [];
  const arrModule = dataMenus.filter(
    (e) => e.screen.sub_module_id === 0 && e.screen.is_show == 1 
  );
  for (let i = 0; i < arrModule.length; i++) {
    let objMenu = arrModule[i].screen;
    let arrSubModule = dataMenus.filter(
      (e) =>
        e.screen.module_id === arrModule[i].screen.module_id &&
        e.screen.sub_module_id > 0 &&
        e.screen.is_show == 1 
    );
    objMenu.subItems = arrSubModule.map((e) => e.screen);
    arrMenu.push(objMenu);
  }
  return arrMenu;
};

const ConvertFormatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const EncodeName = (str) => {
    const uint8Array = new TextEncoder().encode(str);
    return btoa(String.fromCharCode(...uint8Array));
}

const DecodeName = (base64) => {
    const binaryString = atob(base64);
    const bytes = new Uint8Array([...binaryString].map(char => char.charCodeAt(0)));
    return new TextDecoder().decode(bytes);
}

export { ConvertDataMenuForShow, ConvertFormatDate, EncodeName, DecodeName };
